var React = require('react');

function MonitorStand (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"x1":"50%","y1":"50%","x2":"50%","y2":"100%","id":"monitor-stand-gradient"},[React.createElement("stop",{"stopColor":"#E0E5E7","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#FFF","offset":"100%","key":1})])),React.createElement("path",{"d":"M118.997 0h78.795l4.225 60.99c1.588 14.266 6.24 23.444 13.958 27.536 7.717 4.091 14.695 8.233 20.932 12.424 2.84 3.13-1.119 4.694-11.876 4.694H118.8V0h.197v105.644H12.765C2.01 105.644-1.95 104.08.89 100.95c6.237-4.191 13.215-8.333 20.932-12.424 7.717-4.092 12.37-13.27 13.958-27.536L40.005 0h78.992z","fill":"url(#monitor-stand-gradient)","fillRule":"nonzero","key":1})]);
}

MonitorStand.defaultProps = {"width":"238","height":"106"};

module.exports = MonitorStand;

MonitorStand.default = MonitorStand;
